import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { Formik } from 'formik';
import useBuildUpdatePlaidRows from './buildUpdatePlaidRows.helper';
import { useTranslation } from 'react-i18next';
import { UtilButton } from 'UI';

const { Box, Button, Title, Table, TextField } = vp;

type UpdatePlaidProps = {
  onSubmit: (params: vp.SetPlaidCredentialsRequest) => void;
  onBack: () => void;
  defaultValues: vp.SetPlaidCredentialsRequest;
};
type FC = FunctionComponent<UpdatePlaidProps>;

const UpdatePlaidReview: FC = (props: UpdatePlaidProps) => {
  const { onSubmit, defaultValues, onBack } = props;
  const updatePlaidRows = useBuildUpdatePlaidRows();
  const { t } = useTranslation('translations', { keyPrefix: 'Integrations.Plaid.Update.Review' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  return (
    <Formik enableReinitialize initialValues={defaultValues} onSubmit={onSubmit} validateOnChange validateOnBlur>
      {({ values, handleSubmit }) => {
        const updatePlaidTable: vp.TableProps = {
          name: 'update-plaid-fields',
          variant: 'pair',
          columns: {
            Field: { header: 'Labels' },
            Input: { header: 'Fields' },
          },
          rows: updatePlaidRows.map(({ label, id, preset }) => ({
            Field: label,
            Input: (
              <TextField
                preset={preset}
                key={id}
                name={id}
                variant="background"
                disabled
                onBlur={() => {}}
                onChange={() => {}}
                value={values[id]}
              />
            ),
          })),
        };
        return (
          <form onSubmit={handleSubmit}>
            <Box flx="col" mb="lg" gapSize="16px">
              <UtilButton iconLeft="chevron_left" size="large" onClick={onBack}>
                {tGlobal('Buttons.back')}
              </UtilButton>
              <Title title={t('pageTitle')} />
            </Box>
            <Table {...updatePlaidTable} />
            <Box width="100%" jc="fe" mt="md">
              <Button id="plaid-submit" type="submit" label={tGlobal('Buttons.save')} />
            </Box>
          </form>
        );
      }}
    </Formik>
  );
};

export default UpdatePlaidReview;
